import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AdCaller from 'helpers/ads/adCaller';
import { InnovFallback } from 'helpers/ads/constants';
import JarvisAdUnit from 'helpers/ads/JarvisAdUnit';
import pushNotification from 'helpers/pushnotification/pushnotification';
import { popupManager } from 'utils/popupManager';
import {
  removeScrollListener,
  pageAmountScrolled,
  initiateOptInNotification,
  showNotificationPrompt,
} from 'utils/notification';
import LoadableComponentLoader from 'components_v2/common/LoadableComponentLoader/LoadableComponentLoader';
import { setCookie, getCookie } from 'utils/cookies';
import _get from 'lodash.get';
import { appendScriptToHead } from 'utils/DOMUtils';
import { loadAllAdsFromQueue, loadAdsCampaignStatus } from 'helpers/ads/redux';
import WithAdBlockerDetector from 'components_v2/common/AdBlockerDetector/WithAdBlockerDetector';
import adBlockPromise from 'components_v2/common/AdBlockerDetector/AdBlockDetectUtils';
// import TimesTop10Loader from 'components/TimesTop10/TimesTop10Loader';
//import StickyDiv from 'components/StickyDiv';
//import { isTablet, isIE11 } from 'utils/common';
import WithMiniTv from 'modules/WithMiniTv/WithMiniTv';
import PrimeScreen from 'components/PrimePaymentFlow/PrimeScreen/PrimeScreenLoader';
// import { isPrimeNotActive } from 'utils/primeUtil';
import {
  initiateLocateService,
  // isGoogleBot,
  // getSsoidAndTicket,
} from 'utils/common';
import PrimePaymentFlowCaller from 'components/PrimePaymentFlow/PrimePaymentFlowCaller';
import AlreadyPrimeToastLoader from 'components/PrimeMessages/AlreadyPrimeToastLoader';
import PrimeWelcomePopupLoader from 'components/PrimeWelcomePopup/PrimeWelcomePopupLoader';
import ToiSubscriptionFlowCaller from 'components/ToiSubscription/ToiSubscriptionLoader';
import TOIAssistBannerWidget from 'routes/home/components/desktop/TOIAssistBannerWidget/TOIAssistBannerWidget';
import WithCubeAd from 'modules/WithCubeAd/WithCubeAd';
import {
  loadToiPlusConfig,
  loadUpdatedToiPlusConfig,
} from 'reduxUtils/modules/toiPlusConfig';
import {
  loadTranslationData,
  loadNudgeData,
} from 'reduxUtils/modules/translationConfig';
// import ConsentForm from 'components/Login/ConsentForm';
import AdCube from 'components_v2/common/AdCube';
import WithPopup from 'modules/WithPopup';
import { setSaleNudgeVisibility } from 'reduxUtils/modules/affiliates';
// import GenderPopupLoader from 'components_v2/common/GenderPopup';
import Covid19 from 'components/Covid19SubscriptionWdt';
// import AdFreeNudge from 'components/AdFreeNudge/';
import WithWebViewLoginHook from 'components_v2/common/WebViewLoginHook/WithWebViewLoginHook';
import miniTvStyle from 'components/MiniTvV2/UsPageMiniTvTheme.scss';
import ToiplusFooter from 'components_v2/common/ToiplusFooter/ToiplusFooter';
import ToipNudges from 'components_v2/common/ToipNudges';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
// import CustomNotificationPrompt from '../../common/CustomNotificationPrompt/CustomNotificationPrompt';
import { GEOAPI_URL } from '../../../constants';
// eslint-disable-next-line no-unused-vars
import s from './Layout.scss';
import Header from '../Header';
import Footer from '../Footer';
import { loadGdprData } from '../../../reduxUtils/modules/gdpr';
import {
  loadGeoData,
  loadGeoLocationData,
} from '../../../reduxUtils/modules/geo';
import RenderAds from '../../../routes/home/components/desktop/RenderAds/RenderAds';
import AffiliatesContent from '../../../components/AffiliatesContent/AffiliatesContent';
// eslint-disable-next-line no-unused-vars, import/extensions
import grxlocalStorage from '../../../components_library/utils/grxUtil/grxLocalStorageUtil.js';

const Covid19LoaderWithPopup = WithPopup(Covid19);
// const AdfreeNudgeWithPopup = WithPopup(AdFreeNudge);
// const TimesTop10LoaderWithPopup = WithPopup(TimesTop10Loader);
// const GenderPopupLoaderWithPopup = WithPopup(GenderPopupLoader);

class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showCustomSubscription: false,
      isCustomPopupVisibleOnce: false,
      currentHref: '',
    };
    this.analticsScriptLoaded = false;
    if (typeof window !== 'undefined') {
      window.adBlockerEventSentOnce = false;
    }
    this.customPromptRef = React.createRef();
  }

  componentDidMount() {
    const { isWapView, isNotificationPopupEnabled, templateName } = this.props;
    const { geoinfo = {} } = window;
    if (typeof window.geoinfo === 'object') {
      initiateLocateService(() => {
        this.props.loadGeoData(window.geoinfo);
        this.props.loadGeoLocationData(isWapView);
      });
    } else {
      initiateLocateService(() => {
        appendScriptToHead({
          scriptUrl: GEOAPI_URL,
          callback: this.props.loadGeoLocationData,
        });
      });
    }
    // this.props.loadGeoLocationData(isWapView);
    this.props.loadGdprData();
    this.loadAnalyticsScript();
    this.props.loadAllAdsFromQueue('', '');
    popupManager(
      undefined,
      false,
      this.props.popGeoConfig.web,
      this.props.disablePopUpManager,
    );
    pushNotification.init({
      isCoachMark: true,
      template: templateName,
    });
    if (this.props.adsCampaignStatusUrl) {
      this.props.loadAdsCampaignStatus(this.props.adsCampaignStatusUrl);
    }
    this.props.loadToiPlusConfig(
      this.props.isPrime,
      isWapView,
      geoinfo.Continent,
      geoinfo.region_code,
      geoinfo.CountryCode,
    );
    this.props.loadTranslationData(isWapView, geoinfo.CountryCode);
    this.props.loadTOIPlusNudgeData(isWapView, geoinfo.CountryCode);
    // window.showAdFreeNudge = this.showForceNudge;

    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    this.checkUtmCookie(params);
    if (
      isNotificationPopupEnabled &&
      isNotificationPopupEnabled.web &&
      isNotificationPopupEnabled.web.enabled &&
      isNotificationPopupEnabled.web.enabled === '1' &&
      !getCookie('customLaterClick') &&
      showNotificationPrompt()
    ) {
      this.setState(
        {
          currentHref: window.location.href,
        },
        () => {
          this.initiateCustomSubscription();
        },
      );
    }
    // this.loadAkmaiCDNJS();
    // initiateLocateService();
    if (this.props.hideAdBlockerDetector) {
      adBlockPromise.then(() => {});
    }
  }

  initiateCustomSubscription = () => {
    const { pageType, msid } = this.props;
    if (
      pageType.toLowerCase() === 'home' ||
      pageType.toLowerCase() === 'listing' ||
      pageType.toLowerCase() === 'newslisting'
    ) {
      setTimeout(() => {
        if (!getCookie('notificationNotSupported')) {
          this.setState({
            showCustomSubscription: true,
          });
        }
      }, 5000);
    }
    window.addEventListener(
      'scroll',
      () => {
        const showCustomPopup = pageAmountScrolled(
          pageType,
          msid,
          this.state.currentHref,
        );
        if (showCustomPopup && !getCookie('customLaterClick')) {
          if (!getCookie('notificationNotSupported')) {
            this.setState(prevState => ({
              showCustomSubscription: true,
              isCustomPopupVisibleOnce:
                prevState.currentHref !== window.location.href &&
                !(
                  pageType.toLowerCase() === 'home' ||
                  pageType.toLowerCase() === 'listing' ||
                  pageType.toLowerCase() === 'newslisting'
                )
                  ? false
                  : prevState.isCustomPopupVisibleOnce,
              currentHref: window.location.href,
            }));
          }
        }
      },
      { passive: true },
    );
  };

  closeCustomSubscriptionPopup = isLaterClicked => {
    this.setState({
      showCustomSubscription: false,
      isCustomPopupVisibleOnce: true,
    });
    if (isLaterClicked) {
      setCookie('customLaterClick', 'yes', 1, '/');
      const { headerData, pageType } = this.props;
      const sectionName =
        headerData &&
        headerData.navigation &&
        headerData.navigation.l1 &&
        headerData.navigation.l1[0]
          ? headerData.navigation.l1[0].label
          : '';
      sendGaThroughProps({
        data: {
          gaCategory: 'Notification_Opt-in',
          gaAction: 'Clicked_Later',
          gaLabel: `${
            pageType.toLowerCase() === 'home' ? 'Home' : sectionName
          }-${pageType}`,
        },
      });
    }
  };

  enableIzootoCall = () => {
    initiateOptInNotification();
    this.setState({
      showCustomSubscription: false,
      isCustomPopupVisibleOnce: true,
    });
    const { headerData, pageType } = this.props;
    const sectionName =
      headerData &&
      headerData.navigation &&
      headerData.navigation.l1 &&
      headerData.navigation.l1[0]
        ? headerData.navigation.l1[0].label
        : '';
    sendGaThroughProps({
      data: {
        gaCategory: 'Notification_Opt-in',
        gaAction: 'Clicked_Allow',
        gaLabel: `${
          pageType.toLowerCase() === 'home' ? 'Home' : sectionName
        }-${pageType}`,
      },
    });
  };
  // showForceNudge = () => {
  //   this.setState({ showforcenudge: true });
  // };
  componentDidUpdate(prevProps) {
    this.loadAnalyticsScript();
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    this.checkUtmCookie(params);
    if (
      prevProps.userPrcData !== this.props.userPrcData &&
      this.props.isPrime
    ) {
      this.props.loadUpdatedToiPlusConfig(
        this.props.isPrime,
        this.props.renewNudgeCloseDuration,
      );
    }
  }

  checkUtmCookie = params => {
    if (Object.keys(params).length !== 0 && params.constructor === Object) {
      const cookieName = params.utm_source ? getCookie(params.utm_source) : '';
      if (cookieName == null) {
        const date = new Date();
        date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
        const expires = `; expires=${date.toGMTString()}`;
        document.cookie = `utm_source=${params.utm_source};${expires}`;
        if (params.utm_source === 'admitad') {
          document.cookie = `utm_source_id=${params.admitad_uid};${expires}`;
          document.cookie = `utm_admitad_expires=${date};${expires}`;
        } else {
          document.cookie =
            'utm_source_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        }
      } else if (params.utm_source === 'admitad') {
        const cookieVal = getCookie(params.admitad_uid);
        if (cookieVal == null) {
          const cookieexpire = `; expires=${getCookie('utm_admitad_expires')}`;
          document.cookie = `utm_source_id=${
            params.admitad_uid
          };${cookieexpire}`;
        }
      }
    }
  };
  loadAnalyticsScript() {
    if (!this.analticsScriptLoaded) {
      window.TimesGDPR.common.consentModule.gdprCallback(dataObj => {
        if (
          !dataObj.isEUuser ||
          (dataObj.isEUuser && dataObj.didUserOptOut === false) ||
          dataObj.userRegion === 'CA'
        ) {
          const script = document.createElement('script');
          script.setAttribute(
            'src',
            'https://static.clmbtech.com/ase/2658/3/aa.js',
          );
          script.setAttribute('async', 'async');
          document.body.appendChild(script);
          this.analticsScriptLoaded = true;
        }
      });
    }
  }

  componentWillUnmount() {
    removeScrollListener();
  }

  render() {
    // eslint-disable-next-line react/prop-types
    const {
      query,
      params,
      SidebarComponent,
      hideCyclicNav,
      l2navigationChild,
      desktopAdCode,
      headerData,
      layoutClass,
      commonData,
      showWeatherInC,
      enablePrimeFlow,
      isPrime,
      hideAds,
      skipAds,
      pageType,
      hideLogoMastHead,
      toipLayout,
      headerNavData,
      showToiPlusNudges,
      layoutType,
      userData,
      showTopSearchAtTop,
      isAffiliatePage,
      setSaleNudgeVisibilityFn,
      hideAffiliatesFloatingNudge,
      gutterAdCode,
      userPrcData,
      subSecSeoLocation,
    } = this.props;
    const { isWapView } = params;
    const frmapp = query.frmapp === 'yes' || query.frmapp === 'shorts';
    const prcValue =
      userData && userData.prcValue ? this.props.userData.prcValue : 0;
    const viewClass = frmapp ? 'appView' : 'nonAppView';
    let headerAdCode;
    let gutterAdData;
    if (desktopAdCode && desktopAdCode.adCode) {
      headerAdCode = desktopAdCode;
    } else if (commonData && commonData.ROS) {
      headerAdCode = commonData.ROS;
    }
    if (gutterAdCode && gutterAdCode.adCode) {
      gutterAdData = gutterAdCode;
    } else if (commonData && commonData.gutterAd) {
      gutterAdData = commonData.gutterAd;
    }

    const isUserLoggedIn = userData && userData?.isLoggedIn;

    const childComponents =
      showTopSearchAtTop &&
      this.props.children[this.props.children.length - 1].props.id.includes(
        'topSearch',
      )
        ? [...this.props.children].slice(0, -1)
        : this.props.children;
    return (
      <div className={`${viewClass} ${layoutClass}`}>
        {this.props.pageType === 'Home' &&
          prcValue === 5 &&
          !this.props.isAppView && (
            <>
              <LoadableComponentLoader
                loadableComponentName="SubscriptionStripWrapper"
                isWapView={isWapView}
                userPrcData={userPrcData}
                isAppView={this.props.isAppView}
              />
            </>
          )}
        {(this.props.pageType === 'Home' ||
          this.props.pageType === 'toiplusarticleshow' ||
          this.props.pageType === 'ARTICLESHOW') && <div id="portal-modal" />}
        {showTopSearchAtTop
          ? this.props.children[this.props.children.length - 1]
          : ''}
        {this.props.showCovid19PopUp &&
          !this.props.covid19StickyView && (
            <Covid19LoaderWithPopup popupView={1} />
          )}
        {/* <GenderPopupLoaderWithPopup /> */}
        {/* {!isGoogleBot() && <TimesTop10LoaderWithPopup popupView={1} />} */}
        {!hideAffiliatesFloatingNudge && (
          <AffiliatesContent
            type="floating_sale_nudge"
            // enableWidgetsOnLoad
            filters={{
              pagename: 'any',
            }}
            loadingComponent={<></>}
            onContentLoaded={() => {
              setSaleNudgeVisibilityFn(true);
            }}
            noShowCallback={() => {
              setSaleNudgeVisibilityFn(false);
            }}
          />
        )}

        {!this.props.isPrime &&
          !this.props.params.hideMobileTopBar &&
          !this.props.hideAdCude &&
          !frmapp && <AdCube isWapView={isWapView} />}
        {!this.props.isPrime &&
          !toipLayout &&
          !skipAds && <JarvisAdUnit type="topBand" isWapView={isWapView} />}
        <div>
          {!this.props.isPrime &&
          !hideAds &&
          headerAdCode &&
          headerAdCode.adCode &&
          typeof headerData === 'object' ? (
            <div className={`${s.mastHeadAdWrapper} ${s.atfStickyTillHeader}`}>
              <RenderAds
                adObject={{
                  name: 'masthead',
                  ...headerAdCode,
                  divId: `${headerAdCode.divId}-atf`,
                }}
                noPlaceholder
                adWrapperClass={`desktop_paisa ${s.adstickytillmaxwidth}`}
                colorTheme={headerData.colorTheme}
              />
            </div>
          ) : null}
          {this.state.showCustomSubscription &&
          !this.state.isCustomPopupVisibleOnce ? (
            <div ref={this.customPromptRef}>
              {/* <CustomNotificationPrompt
              clickEnable={this.enableIzootoCall}
              closePopup={this.closeCustomSubscriptionPopup}
              template={pageType}
              sectionName={
                headerData &&
                headerData.navigation &&
                headerData.navigation.l1 &&
                headerData.navigation.l1[0]
                  ? headerData.navigation.l1[0].label
                  : ''
              }
            /> */}
            </div>
          ) : (
            ''
          )}
          {!frmapp && (
            <>
              <Header
                isWapView={isWapView}
                isPrime={this.props.isToiPlus || isPrime}
                hideCyclicNav={hideCyclicNav}
                l2navigationChild={l2navigationChild}
                headerData={headerData}
                forSelectedL2Link={this.props.forSelectedL2Link}
                headerNavData={headerNavData}
                hideTimesPointPopup={this.props.hideTimesPointPopup}
                showWeatherInC={showWeatherInC}
                enablePrimeFlow={enablePrimeFlow}
                pageType={this.props.pageType}
                geolocation={this.props.geolocation}
                showToiPlusEntryPoints={this.props.showToiPlusEntryPoints}
                hideLogoMastHead={
                  layoutType !== 'primeshow' ? hideLogoMastHead : false
                }
                colorTheme={this.props.colorTheme}
                disableTimesPointWidget={this.props.disableTimesPointWidget}
                translationData={this.props.translationData}
                toipLayout={toipLayout}
                showPollutionInfo={this.props.showPollutionInfo}
                userData={this.props.userData}
                layoutType={layoutType}
                isAffiliatePage={isAffiliatePage}
                msid={this.props.msid}
                articleSectionData={this.props.articleSectionData}
                newsData={this.props.newsData}
                liveblogData={this.props.liveblogData}
                enableCityChangeFeature={this.props.enableCityChangeFeature}
                storyTitle={this.props.storyTitle}
                // showPersonaliseForToi prop is for TOI/ETIMES AS
                showPersonaliseForToi={pageType === 'ARTICLESHOW'}
                toiAssistNavEnabled={this.props.toiAssistNavEnabled}
                toiAssistBannerData={this.props.toiAssistBannerData}
                hideL2Label={this.props.hideL2Label}
                l2OverrideWrapperClass={this.props.l2OverrideWrapperClass}
                mastheadImageLogo={this.props.mastheadImageLogo}
                subSecSeoLocation={subSecSeoLocation}
              />
            </>
          )}
        </div>

        {!frmapp &&
          toipLayout &&
          showToiPlusNudges &&
          layoutType !== 'primeshow' &&
          pageType !== 'toiplusnewsletter' && (
            <ToipNudges
              viewType={pageType}
              isWapView={isWapView}
              userData={this.props.userData}
              frmapp={frmapp}
            />
          )}
        {this.props.pageType === 'Home' && (
          <PrimeScreen
            componentName="TopBand"
            theme="white_theme"
            isWapView={isWapView}
          />
        )}
        {/* {pageType !== 'Home' &&
          pageType !== 'HomeUs' &&
          pageType !== 'toiplusplanpage' &&
          this.getPrimeWidgets()} */}
        <div
          className={`contentwrapper clearfix ${(this.props.isPrime &&
            'primetemplateshow') ||
            ''} ${this.props.layoutType || ' '} ${
            this.props.customclasslayoutwrapper
              ? this.props.customclasslayoutwrapper
              : ''
          }`}
        >
          <div className="popupWrapper" />
          {!frmapp &&
          !(
            this.props.miniTvData ||
            (this.props.jarvisMiniTvActive &&
              this.props.jarvisMiniTvActive === 1)
          ) &&
          (isUserLoggedIn || isPrime) &&
          this.props.pageType === 'Home' &&
          this.props.toiAssistBannerData &&
          this.props.toiAssistBannerData.text ? (
            <TOIAssistBannerWidget data={this.props.toiAssistBannerData} />
          ) : null}
          {this.props.showMiniTv &&
            !frmapp && (
              <WithMiniTv
                isWapView={false}
                styleObject={miniTvStyle}
                showMiniTvSection={this.props.showMiniTvSection}
                pageType={this.props.pageType}
                miniTvV2={this.props.miniTvV2}
                overRideClass={this.props.overRideClass}
              />
            )}
          {showTopSearchAtTop ? childComponents : this.props.children}
          {!this.props.isPrime && (
            <WithCubeAd pageType={this.props.pageType} isWapView={isWapView} />
          )}
          {!frmapp &&
            !isWapView &&
            typeof SidebarComponent === 'function' &&
            SidebarComponent.prototype.isReactComponent &&
            this.props.sidebarData && (
              <SidebarComponent data={this.props.sidebarData} />
            )}
          {(!hideAds && this.props?.headerData?.sitesync) ||
          this.props?.common?.sitesync ? (
            <AdCaller
              data={{
                name: 'sitesync',
                ...this.props.headerData.sitesync,
                ...this.props?.common?.sitesync,
              }}
              immediateLoad
            />
          ) : null}
        </div>
        {!frmapp &&
          !params.hideMobileTopBar &&
          !toipLayout && (
            <>
              <Footer
                footerData={this.props.footerData}
                isPrivateUser={this.props.isPrivateUser}
                msid={this.props.msid}
                articleSectionData={this.props.articleSectionData}
                newsData={this.props.newsData}
                liveblogData={this.props.liveblogData}
              />
            </>
          )}
        {!frmapp &&
          !params.hideMobileTopBar &&
          toipLayout &&
          this.props?.footerData && (
            <ToiplusFooter
              footerData={this.props.footerData}
              isPrivateUser={this.props.isPrivateUser}
            />
          )}
        {/* {commonData &&
          commonData.geoAd && (
            <AdCaller
              immediateLoad
              data={commonData.geoAd}
              deviceType="all"
              cookieKey="geolocation"
              byPassIsPrime
            />
          )} */}
        {/* {commonData &&
          commonData.geoState && (
            <AdCaller
              immediateLoad
              data={commonData.geoState}
              deviceType="all"
              cookieKey="geostate"
            />
          )} */}
        <WithWebViewLoginHook frmapp={frmapp} />
        <PrimePaymentFlowCaller />

        {userPrcData &&
          !userPrcData?.gstAddressUpdateRequired && (
            <>
              <PrimeWelcomePopupLoader
                isWapView={isWapView}
                userPrcData={userPrcData}
              />
              <AlreadyPrimeToastLoader
                userData={userData}
                toipLayout={toipLayout}
                layoutType={layoutType}
                isPrime={isPrime}
                msid={this.props.msid}
                storyTitle={this.props.storyTitle}
                userPrcData={userPrcData}
              />
            </>
          )}
        <ToiSubscriptionFlowCaller
          userData={this.props.userData}
          isWapView={isWapView}
          query={query}
          currencyCode={_get(this.props.translationData, 'currencyCode', '')}
          msid={this.props.msid}
          storyTitle={this.props.storyTitle}
          userPrcData={userPrcData}
        />
        {/* {!this.props.consentGiven && (
          <ConsentForm isPrivateUser={this.props.isPrivateUser} overlayView />
        )} */}
        {!this.props.hideAdBlockerDetector &&
          !(
            this.props.hideAdBlockerConfig &&
            this.props.hideAdBlockerConfig === '1'
          ) &&
          !this.props.toipLayout &&
          !this.props.isPrime && <WithAdBlockerDetector />}
        {!hideAds &&
          !this.props.hideGutterAd &&
          gutterAdData && (
            <RenderAds
              noPlaceholder
              adWrapperClass={s.gutter_ad}
              adObject={{
                adType: 'dfp',
                ...gutterAdData,
                name: 'gutter',
                failover: InnovFallback,
                perpetualRefresh: 1,
              }}
            />
          )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isPrime: state.isPrime,
  sidebarData: state.sidebar ? state.sidebar.data : {},
  headerData: state.header?.data,
  //footer: state.footer,
  isPrivateUser: state.gdpr?.isPrivateUser,
  // adsQueueData: state.adCaller.adsQueueData,
  // consentGiven: !(
  //   state.login.userData && state.login.userData.showConsentPopUp
  // ),
  userData: _get(state, 'login.userData', {}),
  currentCountry: _get(state, 'geo.currentCountry', undefined),
  navigationData: state.header?.data,
  footerData: state.footer_v2?.data,
  commonData: state.commonData?.data,
  showGutterFallback: state.common && state.common.showGutterFallback,
  gutterFallbackAdObject: state.common && state.common.gutterFallbackAdObject,

  adsCampaignStatus: state.adCaller.adsCampaignStatus,
  showToiPlusEntryPoints: true,
  // showToiPlusEntryPoints: _get(
  //   state,
  //   'toiplusconfig.showToiPlusEntryPoints',
  //   false,
  // ),
  showToiPlusNudges: state.toiplusconfig?.showToiPlusNudges,
  translationData: _get(state, 'translationConfig.data', {}),
  popGeoConfig: _get(state, 'common.siteConfig.popup', {
    web: {
      enabled: 0,
      geo: {
        IN: '1',
        US: '1',
        ROW: '1',
      },
    },
  }),
  hideAdBlockerConfig: _get(state, 'common.siteConfig.hideAdBlocker', '0'),
  toiAssistNavEnabled: _get(
    state,
    'common.siteConfig.toiAssistNavEnabled',
    '0',
  ),
  articleSectionData: state.articleshow_v2?.data,
  newsData: state.newslisting && state.newslisting.data,
  liveblogData: state.liveblog_v2,
  isNotificationPopupEnabled: _get(state, 'common.siteConfig.notification', {
    web: {
      enabled: '1',
    },
  }),
  userPrcData: state.login.userPrcData,
  miniTvData: state.miniTv?.data,
  jarvisMiniTvActive: state?.common?.siteConfig?.revenue?.minitv?.isAdActive,
  renewNudgeCloseDuration: _get(
    state,
    'translationConfig.nudges.unifiedNodes.preExpiry.renewNudgeCloseDuration',
    24,
  ),
});

const mapDispatchToProps = dispatch => ({
  loadAllAdsFromQueue: (params, path) => {
    dispatch(loadAllAdsFromQueue(params, path));
  },
  loadGdprData: params => {
    dispatch(loadGdprData(params));
  },
  loadGeoData: params => {
    dispatch(loadGeoData(params));
  },
  loadGeoLocationData: params => {
    dispatch(loadGeoLocationData(params));
  },
  loadAdsCampaignStatus: url => {
    dispatch(loadAdsCampaignStatus(url));
  },
  loadToiPlusConfig: (
    isPrime,
    isWapView,
    currentContinent,
    currentRegion,
    currentCountry,
  ) => {
    dispatch(
      loadToiPlusConfig(
        isPrime,
        isWapView,
        currentContinent,
        currentRegion,
        currentCountry,
      ),
    );
  },
  loadUpdatedToiPlusConfig: (isPrime, renewNudgeCloseDuration) => {
    dispatch(loadUpdatedToiPlusConfig(isPrime, renewNudgeCloseDuration));
  },
  loadTranslationData: (isWapView, currentCountry) => {
    dispatch(loadTranslationData(isWapView, currentCountry));
  },
  loadTOIPlusNudgeData: (isWapView, currentCountry) => {
    dispatch(loadNudgeData(isWapView, currentCountry));
  },
  setSaleNudgeVisibilityFn: status => {
    dispatch(setSaleNudgeVisibility(status));
  },
});

Layout.propTypes = {
  layoutClass: PropTypes.string,
  isPrime: PropTypes.bool.isRequired,
  pageType: PropTypes.string,
  SidebarComponent: PropTypes.shape({}),
  translationData: PropTypes.shape({}),
  l2navigationChild: PropTypes.shape({}),
  children: PropTypes.node.isRequired,
  headerData: PropTypes.shape({}).isRequired,
  sidebarData: PropTypes.arrayOf(PropTypes.shape({})),
  query: PropTypes.shape({}).isRequired,
  params: PropTypes.shape({
    fullPath: PropTypes.string.isRequired,
    hideMobileTopBar: PropTypes.bool,
    liveblogHeader: PropTypes.bool,
    refreshAtfAd: PropTypes.bool,
  }).isRequired,
  headerNavData: PropTypes.shape({}),
  // consentGiven: PropTypes.bool,
  loadGdprData: PropTypes.func.isRequired,
  loadGeoData: PropTypes.func.isRequired,
  loadGeoLocationData: PropTypes.func.isRequired,
  loadAllAdsFromQueue: PropTypes.func.isRequired,
  layoutType: PropTypes.string,
  footerData: PropTypes.shape({}),
  desktopAdCode: PropTypes.shape({}),
  subSecSeoLocation: PropTypes.string,
  isPrivateUser: PropTypes.bool,
  // currentCountry: PropTypes.string,
  commonData: PropTypes.shape({ gutterAd: PropTypes.shape({}) }),
  hideAdBlockerDetector: PropTypes.bool,
  hideAdBlockerConfig: PropTypes.string,
  hideCyclicNav: PropTypes.bool,
  hideGutterAd: PropTypes.bool,
  gutterFallbackAdObject: PropTypes.shape({
    lhs: PropTypes.shape({}),
    rhs: PropTypes.shape({}),
  }),
  hideTimesPointPopup: PropTypes.bool,
  showMiniTv: PropTypes.bool,
  showMiniTvSection: PropTypes.string,
  showWeatherInC: PropTypes.bool,
  enablePrimeFlow: PropTypes.bool,
  miniTvV2: PropTypes.bool,
  overRideClass: PropTypes.string,
  userData: PropTypes.shape({
    showConsentPopUp: PropTypes.bool,
  }),

  hideAdCude: PropTypes.bool,
  customclasslayoutwrapper: PropTypes.string,
  hideAds: PropTypes.bool,
  geolocation: PropTypes.string,
  adsCampaignStatusUrl: PropTypes.string,
  loadAdsCampaignStatus: PropTypes.func.isRequired,
  adsCampaignStatus: PropTypes.shape({}),
  skipAds: PropTypes.bool,
  showCovid19PopUp: PropTypes.bool,
  covid19StickyView: PropTypes.bool,
  loadToiPlusConfig: PropTypes.func.isRequired,
  loadUpdatedToiPlusConfig: PropTypes.func.isRequired,
  loadTranslationData: PropTypes.func.isRequired,
  isWapView: PropTypes.bool,
  showToiPlusEntryPoints: PropTypes.bool,
  hideLogoMastHead: PropTypes.bool,
  showToiPlusNudges: PropTypes.bool,
  disablePopUpManager: PropTypes.bool,
  colorTheme: PropTypes.string,
  disableTimesPointWidget: PropTypes.bool,
  toipLayout: PropTypes.bool,
  showPollutionInfo: PropTypes.bool,
  msid: PropTypes.number,
  storyTitle: PropTypes.string,
  showTopSearchAtTop: PropTypes.bool,
  isToiPlus: PropTypes.bool,
  isAffiliatePage: PropTypes.bool,
  setSaleNudgeVisibilityFn: PropTypes.func.isRequired,
  hideAffiliatesFloatingNudge: PropTypes.bool,
  enableCityChangeFeature: PropTypes.bool,
  isNotificationPopupEnabled: PropTypes.shape({}),
  toiAssistBannerData: PropTypes.shape({}),
  miniTvData: PropTypes.shape({}),
  jarvisMiniTvActive: PropTypes.number,
  renewNudgeCloseDuration: PropTypes.number,
};

Layout.defaultProps = {
  layoutClass: '',
  pageType: '',
  SidebarComponent: undefined,
  l2navigationChild: undefined,
  // consentGiven: true,
  sidebarData: [],
  layoutType: '',
  translationData: {},
  //adTheme: '',
  //hideStickyBackToTop: false,
  //mobileAdCode: undefined,
  desktopAdCode: undefined,
  overRideClass: '',
  adsCampaignStatusUrl: undefined,
  hideAdBlockerConfig: '0',
  //hideBreadcrumAtBottom: false,
  showMiniTv: false,
  //deskopTopBannerData: undefined,
  //refreshFBNAd: false,
  hideAdBlockerDetector: false,
  hideCyclicNav: false,
  //pageType: '',
  subSecSeoLocation: '',
  isPrivateUser: true,
  // currentCountry: '',
  //navigationData: undefined,
  footerData: undefined,
  commonData: {},
  hideGutterAd: false,
  gutterFallbackAdObject: undefined,
  hideTimesPointPopup: false,
  showMiniTvSection: '',
  showWeatherInC: false,
  enablePrimeFlow: false,
  miniTvV2: true,
  userData: undefined,
  hideAdCude: false,
  customclasslayoutwrapper: '',
  hideAds: false,
  geolocation: '1',
  adsCampaignStatus: undefined,
  skipAds: false,
  showCovid19PopUp: false,
  covid19StickyView: false,
  isWapView: false,
  showToiPlusEntryPoints: false,
  hideLogoMastHead: false,
  showToiPlusNudges: false,
  disablePopUpManager: false,
  colorTheme: '',
  disableTimesPointWidget: false,
  headerNavData: undefined,
  toipLayout: false,
  showPollutionInfo: false,
  msid: '',
  storyTitle: '',
  showTopSearchAtTop: false,
  isToiPlus: false,
  isAffiliatePage: false,
  hideAffiliatesFloatingNudge: true,
  enableCityChangeFeature: false,
  isNotificationPopupEnabled: {},
  toiAssistBannerData: undefined,
  miniTvData: undefined,
  jarvisMiniTvActive: 0,
  renewNudgeCloseDuration: 24,
};

export default connect(mapStateToProps, mapDispatchToProps)(Layout);
